import { FC, memo } from 'react';
import { Button } from '@/shared/ui';
import styles from './CoursePlayerHeader.module.css';

interface CoursePlayerHeaderProps {
    courseTitle: string;
    formattedSessionTime: string;
    onBack: () => void;
}

/**
 * CoursePlayerHeader component
 * Displays the course title, back button, and session timer.
 */
const CoursePlayerHeader: FC<CoursePlayerHeaderProps> = memo(({
    courseTitle,
    formattedSessionTime,
    onBack,
}) => {
    return (
        <div className={styles.header}>
            <div className={styles.headerLeft}>
                <Button variant="ghost" size="small" onClick={onBack}>
                    ← Back
                </Button>
                <h1 className={styles.courseTitle}>{courseTitle}</h1>
            </div>
            <div className={styles.headerRight}>
                <div className={styles.timer}>
                    ⏱️ {formattedSessionTime}
                </div>
            </div>
        </div>
    );
});

export default CoursePlayerHeader;
